import React, { useEffect } from 'react';
import '../styles/cyberpanel.css';

const CheckIcon = () => (
  <svg className="check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 001.414 0l8-8a1 1 000-1.414z" clipRule="evenodd" />
  </svg>
);

const plans = [
  {
    name: "CyberPanel Bronze",
    discount: "50% off 1st mo",
    price: "$4.98",
    subtitle: "Entry-level CyberPanel VPS for lightweight sites.",
    features: [
      "VPS | Ubuntu 22.04",
      "32+ Regions",
      "CyberPanel",
      "1 vCPU",
      "1GB RAM",
      "25GB NVMe SSD",
      "1TB Bandwidth",
      "IPv4 + IPv6",
      "Daily Backups",
      "Free SSL Certificate",
      "User Management",
      "Full Root Access",
      "24/7 Tech Support",
    ],
  },
  {
    name: "CyberPanel Silver",
    discount: "50% off 1st mo",
    price: "$7.98",
    subtitle: "Balanced CyberPanel server for growing traffic.",
    features: [
      "VPS | Ubuntu 22.04",
      "32+ Regions",
      "CyberPanel",
      "1 vCPU",
      "2GB RAM",
      "55GB NVMe SSD",
      "2TB Bandwidth",
      "IPv4 + IPv6",
      "Daily Backups",
      "Free SSL Certificate",
      "User Management",
      "Full Root Access",
      "24/7 Tech Support",
    ],
  },
  {
    name: "CyberPanel Gold",
    discount: "50% off 1st mo",
    price: "$11.99",
    subtitle: "Scalable CyberPanel VPS with full performance.",
    features: [
      "VPS | Ubuntu 22.04",
      "32+ Regions",
      "CyberPanel",
      "2 vCPU",
      "2GB RAM",
      "65GB NVMe SSD",
      "3TB Bandwidth",
      "IPv4 + IPv6",
      "Daily Backups",
      "Free SSL Certificate",
      "User Management",
      "Full Root Access",
      "24/7 Tech Support",
    ],
  },
];

function Cyberpanel() {
  // Add page-scoped class to <body>
  useEffect(() => {
    document.body.classList.add('cyberpanel-page');
    return () => {
      document.body.classList.remove('cyberpanel-page');
    };
  }, []);

  return (
    <div className="pricing-section">
      <div className="pricing-wrapper">
        {plans.map((plan, index) => (
          <div className="pricing-card" key={index}>
            <div className="discount-badge">{plan.discount}</div>
            <h2>{plan.name}</h2>
            <p className="plan-subtitle">{plan.subtitle}</p>
            <p className="plan-price">
              <span className="price-label">Starting from</span><br />
              <span className="price-amount">{plan.price}<span className="per-month">/mo</span></span>
            </p>
            <a href="https://account.i-word.net/order/config/preconfig/vps_cyberpanel" className="start-btn" target="_blank" rel="noopener noreferrer">START NOW</a>
            <div className="divider"></div>
            <ul className="feature-list">
              {plan.features.map((feature, i) => (
                <li key={i}><CheckIcon /> {feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Cyberpanel;

